module.exports = __webpack_public_path__ + "static/media/perfect-gold_00008.b7e1d244.png";